"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const theme_1 = require("../modules/theme");
class RadioButton extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                radioContainer: {
                    flexDirection: 'row',
                    paddingVertical: 5
                },
                radioButtom: {
                    height: 14,
                    width: 14,
                    borderRadius: 12,
                    borderWidth: 1.2,
                    borderColor: '#cfcfcf',
                    alignItems: 'center',
                    justifyContent: 'center',
                    top: 5
                },
                radioMark: {
                    height: 8,
                    width: 8,
                    borderRadius: 6,
                    backgroundColor: theme.textColor2
                },
                labelRadioButtom: {
                    flex: 1,
                    fontSize: 16,
                    color: theme.textColor1,
                    alignSelf: 'flex-start',
                    left: 10,
                    fontFamily: theme.fontFamily1
                }
            });
            return styles;
        };
    }
    render() {
        const { items, value, onChange } = this.props;
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, null, items.map(item => (React.createElement(react_native_1.TouchableWithoutFeedback, { key: item.value, onPress: () => onChange(item.value) },
            React.createElement(react_native_1.View, { style: styles.radioContainer },
                React.createElement(react_native_1.View, { style: styles.radioButtom }, item.value === value && React.createElement(react_native_1.View, { style: styles.radioMark })),
                React.createElement(react_native_1.Text, { style: styles.labelRadioButtom }, item.label)))))));
    }
}
exports.RadioButton = RadioButton;
